import { useState, useEffect, useRef } from 'react'
import { useLocation, Link, useNavigate } from 'react-router-dom'
// ------ Services ------ //
import * as badgeService from '../../../services/badgeManagementService'
import * as clientEventService from '../../../services/clientEventService'
import * as eventManagementService from '../../../services/eventManagementService'
import BackSaveContinueButton from '../../../components/Miscellaneous/BackSaveContinueButton'
import SelectEvent from '../../../components/Account/ManageAccountSettings/SelectEvent'
import styles from './KioskLandingPageSetup.module.css'
const KioskLandingPageSetup = ({ user }) => {
    const location = useLocation()
    const passedState = location.state
    const navigate = useNavigate()
    const [loaded, setLoaded] = useState(false)
    const [continueButtonVisibility, setContinueButtonVisibility] = useState(true)
    const [eventOptions, setEventOptions] = useState([])
    const [formData, setFormData] = useState(
        {
            id: null,
            clientId: null,
            pageTitle: null,
            eventId: null,
            firstClientEvent: {},
            firstEventLabel:null,
            secondClientEvent: {},
            secondEventLabel: null,
            thirdClientEvent: {},
            thirdEventLabel: null,
            fourthClientEvent: {},
            fourthEventLabel: null,
            active: null,
            client: {}, // needed for SelectEvent
        }
    )

    const [message, setMessage] = useState([''])
    const [clientEventInfo, setClientEventInfo] = useState({})
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current = passedData
        }

    }
    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])
    const [firstEvent, setFirstEvent] = useState({
        event: {},
        eventName: null,
    })

    const [secondEvent, setSecondEvent] = useState({
        event: {},
        eventName: null,
    })

    const [thirdEvent, setThirdEvent] = useState({
        event: {},
        eventName: null,
    })

    const [fourthEvent, setFourthEvent] = useState({
        event: {},
        eventName: null,
    })
    /*   Functions  */
    const clearFirstEvent = () => setFirstEvent({
        event: null,
        eventName: null,
    })
    const clearSecondEvent = () => setSecondEvent({
        event: null,
        eventName: null,
    })
    const clearThirdEvent = () => setThirdEvent({
        event: null,
        eventName: null,
    })
    const clearFourthEvent = () => setFourthEvent({
        event: null,
        eventName: null,
    })

    const ClearAllEvents = () => {
        clearFirstEvent();
        clearSecondEvent();
        clearThirdEvent();
        clearFourthEvent();
    }

    // --- REST --- //
    const createRequestBody = async () => {

        let requestBody = {}

        if (clientEventInfo.clientId && clientEventInfo.eventId) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "eventId": `${clientEventInfo.eventId}`
            }
        }
        return await requestBody;
    }
    const createEventsRequestBody = async () => {

        let requestBody = {}
        if (clientEventInfo.clientId && clientEventInfo.clientName) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "clientName": `${clientEventInfo.clientName}`
            }
        }

        return await requestBody;
    }
    /* -------- Functions -------- */

    const fetchLandingPageSetup = async () => {
        const getReqBody = await createRequestBody()
        const data = await badgeService.getLandingPageSetup(getReqBody)
        if (data) {
            let client = {
                clientName: clientEventInfo.clientName,
                clientId: clientEventInfo.clientId,
            }
            data.client = client;
            setFormData(data)
        }

    }

    // useEffect - placeholder fetch function until controller & backend func is created
    useEffect(() => {
        if (clientEventInfo && clientEventInfo.clientId !== undefined && clientEventInfo.eventId) {
            fetchLandingPageSetup()
        }

    }, [clientEventInfo])

    useEffect(() => {
        if (formData.clientId && eventOptions && eventOptions.length > 0) {
            if (formData.firstClientEvent) {
                var foundEvent = eventOptions.find((item) => item.eventId === formData.firstClientEvent.eventId);
                if (foundEvent) {
                    let eventObject = ({
                        event: foundEvent,
                        eventName: formData.firstClientEvent.name
                    })
                    setFirstEvent(eventObject);
                    formData.firstClientEvent = foundEvent;
                }
                else {
                    formData.firstClientEvent = null;
                }
            }

            if (formData.secondClientEvent) {
                var foundEvent2 = eventOptions.find((item) => item.eventId === formData.secondClientEvent.eventId);
                if (foundEvent2) {
                    let eventObject = ({
                        event: foundEvent2,
                        eventName: formData.secondClientEvent.name
                    })
                    setSecondEvent(eventObject);
                    formData.secondClientEvent = foundEvent2;
                }
                else {
                    formData.secondClientEvent = null;
                }
            }

            if (formData.thirdClientEvent) {
                var foundEvent3 = eventOptions.find((item) => item.eventId === formData.thirdClientEvent.eventId);
                if (foundEvent3) {
                    let eventObject = ({
                        event: foundEvent3,
                        eventName: formData.thirdClientEvent.name
                    })
                    setThirdEvent(eventObject);
                    formData.thirdClientEvent = foundEvent3;
                }
                else {
                    formData.thirdClientEvent = null;
                }
            }

            if (formData.fourthClientEvent) {
                var foundEvent4 = eventOptions.find((item) => item.eventId === formData.fourthClientEvent.eventId);
                if (foundEvent4) {
                    let eventObject = ({
                        event: foundEvent4,
                        eventName: formData.fourthClientEvent.name
                    })
                    setFourthEvent(eventObject);
                    formData.fourthClientEvent = foundEvent4;
                }
                else {
                    formData.fourthClientEvent = null;
                }
            }
        }

    }, [eventOptions && eventOptions.length > 0])

    const fetchEvents = async () => {
        let req = await createEventsRequestBody();
        const events = await eventManagementService.loadEvents(req);
        setEventOptions(events);
    }
    useEffect(() => {
        if (formData.clientId) {
            fetchEvents();
        }

    }, [formData.clientId])

    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }

    }, [])
    const handleChange = (e) => {
        if (e.target.type === 'checkbox') {
            setFormData({
                ...formData,
                [e.target.name]: e.target.checked,
            })
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
        }
    }

    const createSaveRequest = (items) => {
        const fieldsSave = { ...formData}
        if (Object.keys(firstEvent.event).length > 0) {
            fieldsSave.firstClientEventId = firstEvent.event.eventId;
            fieldsSave.firstClientEvent = firstEvent.event;
        }
        if (Object.keys(secondEvent.event).length > 0) {
            fieldsSave.secondClientEventId = secondEvent.event.eventId;
            fieldsSave.secondClientEvent = secondEvent.event;
        }
        if (Object.keys(thirdEvent.event).length > 0) {
            fieldsSave.thirdClientEventId = thirdEvent.event.eventId;
            fieldsSave.thirdClientEvent = thirdEvent.event;
        }
        if (Object.keys(fourthEvent.event).length > 0) {
            fieldsSave.fourthClientEventId = fourthEvent.event.eventId;
            fieldsSave.fourthClientEvent = fourthEvent.event;
        }
        return fieldsSave
    }

    const handleSave = async e => {
        e.preventDefault()
        let saverequest = createSaveRequest();
        try {
            await badgeService.saveLandingPageSetup(saverequest)
           
        } catch (err) {
            setMessage(err.message)
        }

    }
    const handleSaveAndNavigate = async e => {
        e.preventDefault()
        try {
            await handleSave()
            navigate('/KioskManager', { state: clientEventInfo })
        } catch (err) {
            setMessage(err.message)
        }

    }
    return (
        <div className="page-area">
            <div className={styles.templateIndex}>
                <h1>Event Kiosk Landing Page Setup</h1>
                <br /> <br />
                <BackSaveContinueButton
                    continueButtonVisibility={continueButtonVisibility}
                    handleSaveAndNavigate={handleSaveAndNavigate}
                    handleSave={handleSave}
                    styles={styles}
                    navigate={navigate}
                />
                {
                    message ?
                        <h2>{message}</h2> :
                        <></>
                }
                <br />
                <h2>Assign events to the landing page.<br />Only have to setup once, rest will be paired.</h2>
                <h3>
                    <div className={styles.wrapper}>
                        Active - True - Enables navigation. <br />
                        Page Title - Name shown at top of scanner page screen (typically event name). <br />
                        Event (1-4) - Button navigation to event.<br />
                        Event Label (1-4) - Label for event button.<br />
                    </div>

                </h3>
                <div >
                    <div className={styles.inputContainer}>
                        <label title="True - used in navigation.">
                            Active: <input
                                type="checkbox"
                                autoComplete="off"
                                checked={formData.active ? true : false}
                                name="active"
                                onChange={handleChange}
                                style={{
                                    width: '10%',
                                }}
                            />

                        </label>

                    </div>
                    <div className={styles.inputContainer}>
                        <label title="Name shown at top of landing page screen (typically event name).">
                            Page Title: <input
                                className={styles.landPageInput}
                                type="text"
                                value={formData.pageTitle}
                                name="pageTitle"
                                onChange={handleChange}
                            />

                        </label>
                    </div>
                    {clientEventInfo.clientName && formData.clientId ?
                        <div>
                            <label title="Override name for button.">
                                First Event Label: <input
                                    className={styles.landPageInput}
                                    type="text"
                                    value={formData.firstEventLabel}
                                    name="firstEventLabel"
                                    onChange={handleChange}
                                />

                            </label>
                            <SelectEvent
                                formData={formData}
                                eventInfo={firstEvent}
                                setEvent={setFirstEvent}
                                listEvents={eventOptions}
                                key={formData.clientName ? formData.clientName + "1" : "1"}
                            />
                        </div>

                        : <></>
                    }
                    {clientEventInfo.clientName && formData.clientId && firstEvent && firstEvent.eventName ?
                        <div>
                            <label title="Override name for button.">
                                Second Event Label: <input
                                    className={styles.landPageInput}
                                    type="text"
                                    value={formData.secondEventLabel}
                                    name="secondEventLabel"
                                    onChange={handleChange}
                                />

                            </label>
                            <SelectEvent
                                formData={formData}
                                eventInfo={secondEvent}
                                setEvent={setSecondEvent}
                                listEvents={eventOptions}
                                key={formData.clientName ? formData.clientName + "2" : "2"}
                            />
                        </div>

                        : <></>
                    }
                    {clientEventInfo.clientName && formData.clientId && secondEvent && secondEvent.eventName ?
                        <div>
                            <label title="Override name for button.">
                                Third Event Label: <input
                                    className={styles.landPageInput}
                                    type="text"
                                    value={formData.thirdEventLabel}
                                    name="thirdEventLabel"
                                    onChange={handleChange}
                                />

                            </label>
                            <SelectEvent
                                formData={formData}
                                eventInfo={thirdEvent}
                                setEvent={setThirdEvent}
                                listEvents={eventOptions}
                                key={formData.clientName ? formData.clientName + "3" : "3"}
                            />
                        </div>

                        : <></>
                    }
                    {clientEventInfo.clientName && formData.clientId && thirdEvent && thirdEvent.eventName ?
                        <div>
                            <label title="Override name for button.">
                                Fourth Event Label: <input
                                    className={styles.landPageInput}
                                    type="text"
                                    value={formData.fourthEventLabel}
                                    name="fourthEventLabel"
                                    onChange={handleChange}
                                />

                            </label>
                            <SelectEvent
                                formData={formData}
                                eventInfo={fourthEvent}
                                setEvent={setFourthEvent}
                                listEvents={eventOptions}
                                key={formData.clientName ? formData.clientName + "4" : "4"}
                            />
                        </div>

                        : <></>
                    }

                    <hr></hr>
                    <br /> <br />
                    <BackSaveContinueButton
                        continueButtonVisibility={continueButtonVisibility}
                        handleSaveAndNavigate={handleSaveAndNavigate}
                        handleSave={handleSave}
                        styles={styles}
                        navigate={navigate}
                    />
                    <br />
                </div>

            </div>
        </div>
    );
}

export default KioskLandingPageSetup;